export const ROUTES = {
  FAQ: '/faq',
  HOME: '/',
  LOBBY: '/lobby',
  EXPLORE_GAMES: '/explore-games',
  ROOM: '/room',
  STREAM: '/stream',
};
